<template>
  <qtm-content-block collapsible :title="title">
    <qtm-textarea
      v-bind="$attrs"
      auto-grow
      placeholder="A summary of the work to be done."
      rows="1"
    />
  </qtm-content-block>
</template>

<script setup lang="ts">
export interface Props {
  title?: string
}
withDefaults(defineProps<Props>(), {
  title: 'Order Description'
})
</script>
